import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials ensures the httpOnly session cookie is sent with every request.
// We no longer read/write tokens client-side — the cookie is set/cleared by the backend.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function downloadFile(endpoint, params, filename) {
  const res = await api.get(endpoint, { params, responseType: "blob" });
  downloadBlob(res.data, filename);
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" • ");
  return String(d);
}
